/*global df, global, google */

/*eslint no-async-promise-executor: "off"*/
const gLoader = g => { var h, a, k, p = "The Google Maps JavaScript API", c = "google", l = "importLibrary", q = "__ib__", m = document, b = window; b = b[c] || (b[c] = {}); var d = b.maps || (b.maps = {}), r = new Set, e = new URLSearchParams, u = () => h || (h = new Promise(async (f, n) => { await (a = m.createElement("script")); e.set("libraries", [...r] + ""); for (k in g) e.set(k.replace(/[A-Z]/g, t => "_" + t[0].toLowerCase()), g[k]); e.set("callback", c + ".maps." + q); a.src = `https://maps.${c}apis.com/maps/api/js?` + e; d[q] = f; a.onerror = () => h = n(Error(p + " could not load.")); a.nonce = m.querySelector("script[nonce]")?.nonce || ""; m.head.append(a) })); d[l] ? console.warn(p + " only loads once. Ignoring:", g) : d[l] = (f, ...n) => r.add(f) && u().then(() => d[l](f, ...n)) };

class PlaceAutocompleteComponent extends df.WebBaseControl {
    constructor(sName, oParent) {
        super(sName, oParent);
        this._sControlClass = 'place-autocomplete';

        this.prop(df.tString, 'psGoogleAPIKey');
        this.prop(df.tString, 'psCountry', 'dk');
        this.event('OnPlaceSelect');
    }

    openHtml(aHtml) {
        super.openHtml(aHtml);
        aHtml.push(`<div id="${this._sControlId}" style="background-color: white"></div>`);
    }

    async afterRender() {
        this._eControl = df.dom.query(this._eElem, `#${this._sControlId}`);
        super.afterRender();
        gLoader({ key: this.psGoogleAPIKey, v: 'beta' });
        const { PlaceAutocompleteElement } = await google.maps.importLibrary('places');
        const options = {};
        if (this.psCountry) {
            options.componentRestrictions = { country: this.psCountry };
        }
        const placeAutocomplete = new PlaceAutocompleteElement(options);
        this._eControl.appendChild(placeAutocomplete);

        placeAutocomplete.addEventListener('gmp-select', async ({ placePrediction }) => {
            const place = placePrediction.toPlace();
            await place.fetchFields({
                fields: ['displayName', 'formattedAddress', 'addressComponents', 'location', 'viewport'],
            });
            console.log('Selected place:', place.toJSON());
            this.fire('OnPlaceSelect', [JSON.stringify(place.toJSON())]);
        });
    }
}

export default global.PlaceAutocompleteComponent = PlaceAutocompleteComponent;